/**
 * snapshot قراءة-فقط للجلسة الحاليّة، يُحدَّث من `AuthContext` مرّةً واحدة.
 *
 * الهدف: تجنّب نداء `supabase.auth.getUser()` أو `getSession()` من خارج
 * `AuthContext`، لأن كل نداء يحاول الاستحواذ على `navigatorLock` نفسه
 * ويسبّب runtime errors من نوع:
 *   "Lock 'lock:sb-...-auth-token' was released because another request stole it"
 *
 * أي helper في الواجهة يحتاج الـ user_id أو الـ access_token (مثل
 * trackers، analytics، funnels) يجب أن يستعمل هذا الـ snapshot،
 * لا أن ينادي supabase.auth مباشرة.
 */
import type { Session } from "@supabase/supabase-js";
import { recoveryEligibilityState } from "./cartRecovery";

let currentSession: Session | null = null;
let identityRevision = 0;

/** يُستدعى من AuthContext فقط — لا تستعمله في مكان آخر. */
export function setAuthSnapshot(session: Session | null): void {
  if ((currentSession?.user?.id ?? null) !== (session?.user?.id ?? null)) identityRevision++;
  currentSession = session;
  recoveryEligibilityState.setOwner(session?.user?.id ?? null);
}

/** قراءة فوريّة بلا قفل ولا async. آمنة من أيّ مكان. */
export function getAuthSnapshot(): {
  userId: string | null;
  accessToken: string | null;
  identityRevision: number;
} {
  return {
    userId: currentSession?.user?.id ?? null,
    accessToken: currentSession?.access_token ?? null,
    identityRevision,
  };
}
